import { render, staticRenderFns } from "./ButtonTogglePowerBall.vue?vue&type=template&id=51472541&scoped=true&lang=pug"
import script from "./ButtonTogglePowerBall.vue?vue&type=script&lang=js"
export * from "./ButtonTogglePowerBall.vue?vue&type=script&lang=js"
import style0 from "./ButtonTogglePowerBall.vue?vue&type=style&index=0&id=51472541&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51472541",
  null
  
)

export default component.exports